import React, {useMemo} from 'react';
import {Autocomplete, Chip, Stack, TextField} from '@mui/material';
import {ProblemType} from '../../api/Model';
import {autocompleteChangeEvent, SetState} from '../../util/FormHandlers';
import {TextFieldProps} from '@mui/material/TextField/TextField';

const PROBLEM_TYPE_LABELS: Record<ProblemType, string> = {
    'employee-with-several-keys': 'Employee with several keys',
    'not-returned-keys': 'Not returned keys',
    'lost-keys': 'Lost keys',
    'damaged-keys': 'Damaged keys',
    'keys-with-multiple-active-records': 'Keys with multiple active records'
};

const PROBLEM_TYPES: ProblemType[] = Object.keys(PROBLEM_TYPE_LABELS) as ProblemType[];

export function ProblemTypeSelect({value, setValue, ...props}: {
    value: ProblemType[];
    setValue: SetState<ProblemType[]>;
} & TextFieldProps) {
    const handleOnChange = useMemo(
        () => autocompleteChangeEvent((newValue: ProblemType[]) => {
            setValue(newValue);
        }),
        [setValue]
    );

    return (
        <Autocomplete<ProblemType, true>
            multiple
            options={PROBLEM_TYPES}
            value={value}
            onChange={handleOnChange}
            getOptionLabel={(option) => PROBLEM_TYPE_LABELS[option] || option}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...props}
                />
            )}
            renderValue={(selected: ProblemType[]) =>
                <Stack direction="row" gap={1} flexWrap="wrap" maxWidth={400}>
                    {selected.map((option, index) => (
                        <Chip
                            key={index}
                            label={PROBLEM_TYPE_LABELS[option] || option}
                            size="small"
                            onDelete={() => {
                                setValue(selected.filter((_, i) => i !== index));
                            }}
                        />
                    ))}
                </Stack>
            }
        />
    );
}
